import React from 'react';
import { Icon } from '@material-ui/core';
import { ActionInfoOnCustomerInfo } from '../../../external/CustomerListApi';
import { ACTION_TAG, ACTION_TIME_TYPE, DAY_TYPE, stringDateToFormatString } from '../../../Common';

export type UpcomingActionScheduleProps = ActionInfoOnCustomerInfo;

const componentName = 'UpcomingActionSchedule';

const UpcomingActionSchedule: React.FC<UpcomingActionScheduleProps> = ({
  actionType,
  dayType,
  actionDate,
  actionTimeType,
  actionTimeFrom,
  actionTimeTo,
}) => {
  const actionTag = actionType in ACTION_TAG ? ACTION_TAG[actionType] : undefined;
  const displayActionIcon = actionTag?.icon;
  const displayActionTypeName = actionTag?.name;
  // アクション区分が不正値の場合nullを返す(通常のオペレーションでは発生しない)
  // 以下、不正な値の定義
  // iconも、nameも両方必要なため、どちらかが存在しない場合はnullを返す
  if (!(displayActionIcon && displayActionTypeName)) return null;

  // アクション予定日(日付レベル)の表示内容を決定
  // dayTypeが'3'の場合はactionDateを表示、それ以外の場合はdayTypeに対応する区分名(平日、休日)を表示
  const displayActionDate =
    dayType === '3'
      ? actionDate
        ? stringDateToFormatString(actionDate, 'yyyy-MM-dd', 'MM/dd')
        : DAY_TYPE[0].name // 日付指定選択時に、日付入力がない場合は、"日付予定なし"と表示
      : dayType in DAY_TYPE
      ? DAY_TYPE[dayType].name
      : undefined;

  // アクション日付区分または、アクション日付が不正値の場合nullを返す(通常のオペレーションでは発生しない)
  // 以下、不正な値の定義
  // dayTypeが'3'の場合はactionDateが必須となるため、actionDateが存在しない場合もnullを返す
  // dayTypeが'3'以外の場合は、dayTypeがDAY_TYPEに存在する必要があるため、DAY_TYPEに存在しない場合もnullを返す
  if (!displayActionDate) return null;

  // アクション予定日(時間帯レベル)の表示内容を決定
  // actionTimeTypeが'01'の場合はactionTimeFromとactionTimeToを使用して表示、それ以外の場合はACTION_TIME_TYPEに基づいて表示
  const emptyTimeText = '時刻選択なし';
  const displayActionTimeFrom = actionTimeFrom || emptyTimeText;
  const displayActionTimeTo = actionTimeTo || emptyTimeText;
  const displayActionTime =
    actionTimeType === '01'
      ? !actionTimeFrom && !actionTimeTo
        ? emptyTimeText
        : `${displayActionTimeFrom}〜${displayActionTimeTo}`
      : actionTimeType in ACTION_TIME_TYPE
      ? ACTION_TIME_TYPE[actionTimeType].name
      : undefined;

  // アクション予定時刻区分が不正値の場合nullを返す(通常のオペレーションでは発生しない)
  // 以下、不正な値の定義
  // actionTimeTypeが'01'の場合は不正な値は存在しないが、
  // actionTimeTypeが'01'以外の場合は、actionTimeTypeがACTION_TIME_TYPEに存在する必要があるため、ACTION_TIME_TYPEに存在しない場合もnullを返す
  if (!displayActionTime) return null;

  return (
    <div data-testid={componentName} data-testid-e2e={componentName}>
      <Icon
        className='u-text-3l u-text-middle u-mr4'
        data-testid={`${componentName}-actionIcon`}
        data-testid-e2e={`${componentName}-actionIcon`}
        aria-label={displayActionTypeName} // アクセシビリティ改善: アイコンの意味を説明
      >
        {displayActionIcon}
      </Icon>
      <p className='u-inline-block u-text-m'>
        <span data-testid={`${componentName}-datetime-info`} data-testid-e2e={`${componentName}-datetime-info`}>
          {`${displayActionTypeName}：${displayActionDate} ${displayActionTime}`}
        </span>
      </p>
    </div>
  );
};

export default UpcomingActionSchedule;
